var _path, _g, _g2, _g3, _g4, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1116 14H2.88836C1.29251 14 0 12.8444 0 11.4203V2.57972C0 1.15439 1.29383 0 2.88836 0H11.1116C12.7075 0 14 1.15557 14 2.57972V11.4203C14.0013 12.8444 12.7075 14 11.1116 14Z",
    fill: "url(#paint0_linear_26286_47607)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_47607)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.40039,
    width: 10,
    height: 1.2,
    rx: 0.6,
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_26286_47607)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7.7998,
    width: 10,
    height: 1.2,
    rx: 0.6,
    fill: "white",
    fillOpacity: 0.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_26286_47607)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 10,
    height: 1.2,
    rx: 0.6,
    fill: "white",
    fillOpacity: 0.25
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_26286_47607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16C9.01464 16 7 13.9854 7 11.5C7 9.01464 9.01464 7 11.5 7C13.9854 7 16 9.01464 16 11.5C16 13.9854 13.9854 16 11.5 16Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8192 9.69763C13.5781 9.43412 13.1876 9.43412 12.9472 9.69763L11.158 11.6528C10.9861 11.8407 10.7063 11.8407 10.5344 11.6528L10.0529 11.1266C9.81173 10.8631 9.42126 10.8631 9.18085 11.1266C8.93972 11.3901 8.93972 11.8168 9.18085 12.0795L10.2263 13.2195C10.5694 13.5936 11.126 13.5936 11.4684 13.2187L13.8185 10.6505C14.0604 10.3878 14.0604 9.96113 13.8192 9.69763Z",
    fill: "url(#paint1_linear_26286_47607)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_47607",
    x: -6.81461,
    y: -3.41422,
    width: 27.6292,
    height: 18.8294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_47607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_47607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_26286_47607",
    x: -6.81461,
    y: -1.0148,
    width: 27.6292,
    height: 18.8294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_47607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_47607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_26286_47607",
    x: -6.81461,
    y: -5.81461,
    width: 27.6292,
    height: 18.8294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_47607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_47607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_26286_47607",
    x: -4.54728,
    y: -4.54728,
    width: 32.0946,
    height: 32.0946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.77364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_47607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_47607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_47607",
    x1: -0.291667,
    y1: -1.67708,
    x2: 13.9271,
    y2: 14.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_47607",
    x1: 9,
    y1: 9.8125,
    x2: 12.8006,
    y2: 14.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyCreate);
export default __webpack_public_path__ + "static/media/apply-create.c62844a69cd9ea1eb208ce1a1a477b4a.svg";
export { ForwardRef as ReactComponent };